import { Component } from "react";

// Root safety net: a render error shows a friendly Arabic retry screen instead of a blank white page.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || "" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI crash caught by ErrorBoundary:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div dir="rtl" className="min-h-screen flex items-center justify-center bg-slate-50 p-6 font-body" data-testid="app-error-boundary">
        <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 text-3xl">⚠️</div>
          <h1 className="font-heading text-lg font-bold text-slate-900">حدث خطأ غير متوقع</h1>
          <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">
            تعذّر عرض هذه الصفحة. أعد المحاولة، وإن استمرت المشكلة تواصل مع الدعم.
          </p>
          {this.state.message && (
            <p className="mt-2 rounded-lg bg-slate-50 px-2 py-1 text-[11px] text-slate-400 break-words" dir="ltr">{this.state.message}</p>
          )}
          <div className="mt-4 flex flex-col gap-2">
            <button data-testid="error-reload-btn" onClick={() => window.location.reload()}
              className="h-11 rounded-xl bg-blue-600 font-semibold text-white hover:bg-blue-700">إعادة تحميل الصفحة</button>
            <button data-testid="error-home-btn" onClick={() => { window.location.href = "/"; }}
              className="h-10 rounded-xl border border-slate-200 text-sm font-semibold text-slate-600 hover:bg-slate-50">العودة للرئيسية</button>
          </div>
        </div>
      </div>
    );
  }
}
